import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { LangService } from "src/app/core/services/lang.service";
import { GridService } from "src/app/shared/services/grid.service";
import { DataLoadService } from "src/app/shared/services/data-load.service";

@Component({
  selector: "app-shift-list",
  templateUrl: "./../../../templates/forms/modals/shift-list.component.html"
})
export class ShiftListComponent implements OnInit {
  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "ShiftNameListid";

  @Input()
  optionalParam: any;

  dataObj: any;
  shiftList = [];
  public searchString;
  constructor(
    public langService: LangService,
    public gridService: GridService,
    private dataLoadService: DataLoadService
  ) {
    this.colObj = [
      {
        headerName: langService.langData.shiftId,
        field: "SHIFT_ID",
        sortable: true,
        resizable: true,
        hide: false
      },
      {
        headerName: langService.langData.inTime,
        field: "IN_TIME",
        sortable: true,
        resizable: true,
        hide: false
      },
      {
        headerName: langService.langData.outTime,
        field: "OUT_TIME",
        sortable: true,
        resizable: true,
        hide: false
      }
    ];
  }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    this.getQueartData();
  }

  getQueartData() {
    if (
      typeof this.optionalParam != "undefined" &&
      typeof this.optionalParam.SHOW_FG_HR_COMM_CURRSHIFTTIMING != "undefined"
    ) {
      this.shiftList = [];
      this.dataLoadService
        .load("FG_HR_COMM_CURRSHIFTTIMING")
        .subscribe(result => {
          this.shiftList = result.body;
        });
    }else {
        this.shiftList = [];
        this.dataLoadService
        .load(
          "FG_HR_COMM_SHIFT",
          JSON.parse(JSON.stringify({ P_COMPANY_NO: null }))
        )
        .subscribe(result => {
          this.shiftList = result.body;
        });
    }
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next();
  }
}
